import AbstractInputField from "./AbstractInputField";
import {useEffect, useState} from "react";

const DateField = ({
    value,
    onChange,
    ...otherProps
}) => {
    const formatDate = (v) => {
        if (!v) return '';
        const d = new Date(v);
        if (isNaN(d.getTime())) return '';
        return d.toISOString().split('T')[0];
    };

    const [convertedValue, setConvertedValue] = useState(formatDate(value));

    useEffect(() => {
        setConvertedValue(formatDate(value));
    }, [value]);

    return (
        <AbstractInputField
            type="date"
            value={convertedValue}
            beforeChangeEvent={e => setConvertedValue(e.target.value)}
            afterChangeEvent={e => {
                if (onChange) onChange(e.target.value);
            }}
            {...otherProps}
        />
    );
}

export default DateField;
